var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddClient',{ref:"widget",attrs:{"loading":_vm.loading,"external-id-only":_vm.useFeature('customer_external_id_only')},on:{"submit":_vm.createClient,"closeModal":function($event){return _vm.$emit('closeModal')}}})}
var staticRenderFns = []

export { render, staticRenderFns }